export const GEOFENCE_SLOTS = Object.freeze(["A", "B", "C"]);

export function mapGeofencesToSlots(fences = []) {
  const result = {};
  const unassigned = [];
  for (const fence of fences) {
    if (GEOFENCE_SLOTS.includes(fence?.slot) && !result[fence.slot]) {
      result[fence.slot] = fence;
    } else if (fence) {
      unassigned.push(fence);
    }
  }
  for (const fence of unassigned) {
    const slot = GEOFENCE_SLOTS.find((candidate) => !result[candidate]);
    if (slot) result[slot] = { ...fence, slot, legacySlot: true };
  }
  return result;
}

export function nextAvailableGeofenceSlot(fences = []) {
  const mapped = mapGeofencesToSlots(fences);
  return GEOFENCE_SLOTS.find((slot) => !mapped[slot]) || null;
}
